module.exports = __webpack_public_path__ + "static/img/img-4-2.5c5a8e8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/zbqfBrand/img-4-2.jpg
// module id = HKTe
// module chunks = 0